/**
 * Dashboard.
 *
 * One request for the whole screen. Six panels asking separately would let them
 * disagree with each other for as long as the slowest took.
 */

import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { Dashboard } from '@/api/schema';

export const DASHBOARD_KEY = ['dashboard'] as const;

export function useDashboard(from: string, to: string) {
  return useQuery({
    queryKey: [...DASHBOARD_KEY, from, to],
    queryFn: () => api.get<Dashboard>('/api/v1/dashboard', { query: { from, to } }),
    placeholderData: (previous) => previous,
  });
}
